<template>
  <div class="allWrap mt-5">
      <h4 class="tit1 text-center">{{message}}</h4>
  </div>
</template>
<style lang="scss" scoped>
</style>
<script>
import axios from "axios";
export default {
  data() {
    return {
        message:'',
        timeout:''
    };
  },
  methods: {
      getOrder() {
      axios
        .get(
          `${process.env.VUE_APP_DEFAULT_SRC}/aaa/query?transaction_id=${this.$route.query.transaction_id}`
        )
        .then(res => {
          if (res.data.code == 0) {
            this.message = res.data.message;
          } else {
            this.message = res.data.message;
            clearInterval(this.timeout);
          }
        });
    }
  },
  created() {
      this.getOrder()
    this.timeout = setInterval(() => this.getOrder(), 60000);
  }
};
</script>
